"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const turn_1 = tslib_1.__importStar(require("./turn"));
const __1 = require("../");
const fake_turn_1 = tslib_1.__importDefault(require("./fake-turn"));
function battleProcessor(battle, _, step) {
    switch (step) {
        case 1: {
            battle.addEventProcessor(__1.EventCodes.BATTLE_START, 0, _);
            return 2;
        }
        case 2: {
            battle.runway.compute();
            battle.addEventProcessor(__1.EventCodes.SENKI, 0, _);
            return 3;
        }
        case 3: {
            battle.judgeWin();
            if (battle.isEnd)
                return -1;
            battle.entities.forEach(e => e.turnData.clear()); // 清理回合临时数据
            const nextId = battle.runway.computeNext() || 0;
            if (!nextId)
                return -1;
            const next = battle.getEntity(nextId);
            if (battle.turn >= 1000)
                return 0; // 超时
            const turnData = new turn_1.TurnProcessing(++battle.turn, next.entityId);
            battle.addProcessor(turn_1.default, turnData, 'Turn');
            return 4;
        }
        case 4: {
            if (battle.fakeTurns.length) {
                battle.fakeTurns.forEach(ft => battle.addProcessor(fake_turn_1.default, ft, '伪回合处理'));
                battle.fakeTurns = [];
            }
            return 3;
        }
        default:
            return 0;
    }
}
exports.default = battleProcessor;
